var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaragesale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99533 29.8774C1.44488 29.8749 1 29.4279 1 28.8774V9.39508C1 9.03704 1.19142 8.70632 1.50189 8.52797L14.1091 1.28572C14.4172 1.10876 14.796 1.10852 15.1043 1.28509L27.7503 8.52819C28.0614 8.70636 28.2533 9.03744 28.2533 9.39593V28.9953C28.2533 29.5494 27.8027 29.9979 27.2486 29.9953L1.99533 29.8774Z",
    stroke: "#6D4B40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 26.8836C5.44772 26.8836 5 26.4359 5 25.8836V13C5 12.4477 5.44772 12 6 12H23.2772C23.8266 12 24.2732 12.4433 24.2771 12.9928L24.3697 25.8764C24.3737 26.4315 23.9248 26.8836 23.3697 26.8836H6Z",
    fill: "#f69516",
    stroke: "#6D4B40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 24.1205H24.27",
    stroke: "#6D4B40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21.1205H24.27",
    stroke: "#6D4B40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.1205H24.27",
    stroke: "#6D4B40"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.1205H24.27",
    stroke: "#6D4B40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaragesale);
export default __webpack_public_path__ + "static/media/garagesale.9369757612d3ec4dcb65776bf9ca43ee.svg";
export { ForwardRef as ReactComponent };